import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";

const Screen = lazy(() => import("../../views/auth/ForgotPassword"));

export const Route = createFileRoute("/_public/forgot-password")({
  component: RouteComponent,
  staticData: {
    routeKey: "forgotPassword",
    access: "public-auth",
    layout: "modern",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
